import * as ActionTypes from '../../constants/ActionTypes';

const initialState = {
	educationBackground: [],
	loading: false,
	loadingSubmit: false
};

export default function educationBackgroundPageReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_EDUCATION_BACKGROUND_BY_APPLICATION_ID_REQUEST:
		case ActionTypes.GET_EDUCATION_BACKGROUND_BY_APPLICATION_ID_ERROR:
		case ActionTypes.GET_EDUCATION_BACKGROUND_BY_APPLICATION_ID_SUCCESS:
		case ActionTypes.SUBMIT_EDUCATION_BACKGROUND_REQUEST:
		case ActionTypes.SUBMIT_EDUCATION_BACKGROUND_ERROR:
		case ActionTypes.SUBMIT_EDUCATION_BACKGROUND_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_EDUCATION_BACKGROUND_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_EDUCATION_BACKGROUND_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
